<template>
    <div>
        <div class="list" v-for="item in listData.item" :key="item.id">
          <div v-if="item.id == 5 || item.id == 8 || item.id == 7 || item.id == 4 || item.id == 11 || item.id == 6 || item.id == 13 || item.id == 12 || item.id == 15 || item.id == 16  || item.id == 17 || item.id == 18 || item.id == 19 || item.id == 20 || item.id == 21 || item.id == 22">
            <div class="list-txt">{{ item.name }}</div>
            <p class="tips" v-if="item.id == 17">{{ $t('guild_page_fee') }}</p>
            <div style="display:flex;flex-wrap: wrap;">
              <template v-for="Aitem in item.list">
                <div
                v-if="Aitem.id != 0"
                class="list-box"
                  :key="Aitem.id"
                  @click="channelBtn(item, Aitem)"
                >
                  <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                  <div class="money-box">
                    <img
                      class="money-img"
                      src="../../assets/withdrawal/coin.png"
                      alt=""
                    />
                    <div class="money-num">{{ Aitem.usd }}</div>
                  </div>
                </div>
              <div class="custom-amount-btn list-box" v-if="item.freeAmountEnabled && Aitem.id == 0" @click="inputAmount(item, Aitem,1)">{{ $t('withdraw_input_amount') }}</div>
              </template>
            </div>
          </div>
          <div v-else-if="item.id == 10 || item.id == 9">
            <div class="list-txt">{{ item.name }}</div>
            <div style="display:flex;flex-wrap: wrap;">
              <template v-for="Aitem in item.list">
                <div class="list-box"
                  v-if="Aitem.id != 0"
                  :key="Aitem.id"
                  @click="channelPixBtn(item, Aitem)"
              >
                <div class="money">{{ Aitem.cc }} {{ Aitem.num }}</div>
                <div class="money-box">
                  <img
                      class="money-img"
                      src="../../assets/h5/95a1eb22-e449-4d6a-9643-dd86329ef1b5.png"
                      alt=""
                  />
                  <div class="money-num">{{ Aitem.usd }}</div>
                </div>
              </div>
              <div class="custom-amount-btn list-box"  v-if="item.freeAmountEnabled && Aitem.id == 0" @click="inputAmount(item, Aitem,2)">{{ $t('withdraw_input_amount') }}</div>
              </template>
            </div>
          </div>
          
        </div>

        <div class="meta-box" v-if="loading">
            <van-loading
                type="spinner"
                color="#cccccc"
                size="20px"
            />
        </div>
    <van-popup
      v-model:show="show"
      closeable
      round
      position="bottom"
      :style="{ height: '20%' }"
      class="popup"
      >{{ $t("withdrawalLogin.Pocket") }}</van-popup
    >

      <!-- 自定义弹窗 -->
      <div v-if="showPop" class="custom-popup-mask" @click="closePopup">
        <div class="amount-box" :class="{'keyboard-active': keyboardShow}" @click.stop>
          <p class="amount-title">{{ $t('withdraw_submit') }}</p>
          <div class="to-number">{{ $t('withdraw_quantity') }}</div>
          <div class="input-wrapper" @click="inputFocus">
            <!-- 图标 + 输入框整体居中 -->
            <img src="../../assets/withdrawal/coin.png" alt="coin" class="coin-icon" />
            <!-- 隐藏的测量元素 -->
            <span
            ref="measureRef"
            class="measure"
            aria-hidden="true"
            >{{ inputValue }}</span>
            <input
            ref="inputRef"
              v-model="inputValue"
              type="text"
              inputmode="decimal"
              placeholder=""
              class="center-input"
              @input="changeCoin"
              @click.stop="inputFocus"
              @blur="handleBlur"

            />
          </div>
          <p class="tp-number-tips">{{ $t('guild_current_withdrawable_pcoin') }}<span>{{ coin.toLocaleString('en-US') }}</span></p>
          <ul class="gear-box">
            <li :class="gearType == 0 ? 'act-gear' : ''" @click="changeGearType(0)">{{ $t('guild_all') }}</li>
            <li :class="gearType == 1 ? 'act-gear' : ''" @click="changeGearType(1)">1/2</li>
            <li :class="gearType == 2 ? 'act-gear' : ''" @click="changeGearType(2)">1/3</li>
            <li :class="gearType == 3 ? 'act-gear' : ''" @click="changeGearType(3)">1/4</li>
          </ul>
          <p class="acual-amount">{{ $t('withdraw_actual_received') }}</p>
          <div class="acual-num" v-if="errorAcual == 0">
            <span>{{ currency }}</span>{{ acualNum.toLocaleString('en-US') }}</div>
            <div class="amount-min" v-else-if="errorAcual == 1">{{ $t('withdraw_error_min_amount') }}</div>
            <div class="amount-min" v-else-if="errorAcual == 2">{{ $t('withdraw_error_max_amount') }}</div>
            <div class="amount-min" v-else-if="errorAcual == 3">{{ $t('withdraw_error_max_p_coin') }}</div>
          <div class="pop-btn-box">
            <span @click="closePopup">{{ $t('common_cancel') }}</span>
            <span :class="{'btn-disabled': acualNum <= 0 || errorAcual != 0}" @click="submitPay">{{ $t('common_confirm') }}</span>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import axios from "axios";
import { Toast,Popup,Loading } from "vant";
    export default {
        name: "withdrawal-list",
        props: ['parentCoin'],
        components: {
            VanPopup: Popup,
            [Loading.name]: Loading 
        },
        watch: {
            parentCoin: {
                handler(newVal) {
                    if(newVal) {
                        this.coin = Number(newVal);
                    }
                },
                immediate: true
            }
        },
        data() {
            return {
                client: 'PC',
                listData: {},
                token: "",
                uid: "",
                lang: "",
                show: false,
                deviceId: '',
                loading:false,
                showPop: false,
                inputValue:0,
                placeholder:'',
              //   档位类型
                gearType:5,
                coin:0,
                // 实际到账金额
                acualNum:0,
                // 任意金额提现数据
                customizeItem:{},
                customizeAitem:{},
                // 到账币种
                currency:'',
                // 支付方式 2是id 9 10 1是其他
                payType: 1,
                // 金额错误 
                errorAcual: 0,
                // 键盘是否弹出
                keyboardShow: false,
                // 防抖定时器
                debounceTimer: null
            }
        },
        created(){
            var ids = navigator.userAgent.match(
            /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
            );
            if (ids) {
            ids = ids[0];
            } else {
            ids = "Unknown Device";
            }
            let data = JSON.parse(localStorage.getItem("data"));
            this.token = data.token;
            this.uid = data.uid || data.userId;
            this.lang = data.lang || navigator.language;
            this.deviceId = data.deviceId || ids
            this.contact();
            if(data.uid){
                this.changeTime()
            }
            this.judgeClient();
        },
        mounted(){
        },
        beforeUnmount(){
            // 清除防抖定时器
            if(this.debounceTimer){
                clearTimeout(this.debounceTimer);
            }
        },
        methods: {
          // 跳转支付信息
          submitPay(){
            if(this.errorAcual != 0 || this.acualNum <= 0) return;
            this.customizeAitem.cc = this.customizeAitem.currency;
            this.customizeAitem.num = this.acualNum;
            this.customizeAitem.usd = this.inputValue;
            // 恢复背景滚动
            document.body.style.overflow = '';
            if(this.payType == 1){
              this.channelBtn(this.customizeItem,this.customizeAitem)
            }else{
              this.channelPixBtn(this.customizeItem,this.customizeAitem)
            }
          },
          // 修改档位
          changeGearType(type){
              if(this.gearType == type){
                this.gearType = 5;
                this.inputValue = 0;
              }else{
                this.gearType = type;
                if(type == 0){
                    this.inputValue = this.coin;
                }else if(type == 1){
                    this.inputValue = Math.floor(this.coin/2);
                }else if(type == 2){
                    this.inputValue = Math.floor(this.coin/3);
                }else if(type == 3){
                    this.inputValue = Math.floor(this.coin/4);
                }
              }
              this.changeCoin()
          },
          // 比较输入值是否合法
          inputValueLegal(){
              if(Number(this.inputValue) > Number(this.coin)){
                this.errorAcual = 3;
              }else{
                this.errorAcual = 0;
              }
          },
          // 调整input宽度
          changeCoin(){
              // 只保留整数，去除0开头
              this.inputValue = this.inputValue.toString().replace(/[^\d]/g, '').replace(/^0+/, '') || '';
              this.inputValueLegal();
              this.$nextTick(() => {
                  const span = this.$refs.measureRef;
                  if (span) {
                      // 获取内容宽度（包含 padding）
                      const width = span.offsetWidth;
                      // 设置最小宽度防止太窄
                      this.inputWidth = width+20; // +20 是左右 padding
                      if(this.inputValue.length > 5){
                          this.inputWidth = width+40;
                      }
                      if(this.inputValue.length > 9){
                          this.inputWidth = width+60;
                      }
                      if(this.inputValue.length > 13){
                          this.inputWidth = width+80;
                      }
                      // 应用到 input
                      this.$refs.inputRef.style.width = this.inputWidth + 'px';
                  }
                  this.changeAcualNum()
              });
          },
          // 展示输入金额弹窗
          inputAmount(item, Aitem,type){
            this.showPop = true;
            this.customizeItem = item;
            this.customizeAitem = Aitem;
            this.payType = type;
            // 禁止背景滚动
            document.body.style.overflow = 'hidden';
          },
          // 关闭输入金额弹窗
          closePopup(){
            this.showPop = false;
            this.keyboardShow = false;
            this.acualNum = 0;
            this.currency = '';
            this.inputValue = 0;
            this.gearType = 5;
            // 恢复背景滚动
            document.body.style.overflow = '';
          },
          // 计算实际到账金额
          changeAcualNum(){
            if(this.debounceTimer){
                clearTimeout(this.debounceTimer);
            }
            this.acualNum = 0;
            this.errorAcual = 0;
            if(Number(this.inputValue) == 0) return;
            this.debounceTimer = setTimeout(() => {
                this.fetchAcualNum();
            }, 500);
          },
          // 请求实际到账金额
          fetchAcualNum(){
            axios({
            url: this.$serviceIp + `api/trade/card/tx/preview`,
            method: "post",
              headers: {
                'deviceId': this.deviceId,
                'version': '3.0',
                'lang': this.lang,
              },
            data: {
              cid: this.customizeAitem.channel,
              pocketCoin: Number(this.inputValue),
            },
            params: { token: this.token, uid: this.uid },
          }).then((res) => {
            if (res.data.code == 200) {
              let finalAmount = res.data.data.finalAmount > 0 ? res.data.data.finalAmount : 0;
              if(Number(finalAmount) < Number(res.data.data.minUsd) ){
                  this.errorAcual = 1;
                  return;
                }else if(Number(finalAmount) > Number(res.data.data.maxUsd) ){
                  this.errorAcual = 2;
                  return;
                }else{
                  this.errorAcual = 0;
                }
                this.acualNum = finalAmount;
                this.currency = res.data.data.currency;
            } else {
              Toast(res.data.message || this.$t("transfer.error"));
            }
          });
          },
          inputFocus(){
              this.gearType = 5;
              this.keyboardShow = true;
              const input = this.$refs.inputRef;
              // 如果值为0，就清空
              if(this.inputValue === 0 || this.inputValue === '0'){
                this.inputValue = '';
              }
              this.$nextTick(() => {
                input.focus();
                const len = input.value.length;
                input.setSelectionRange(len, len);
              });
          },
          handleBlur(){
              // 如果失焦时内容为空，设置为0
              if(!this.inputValue || this.inputValue === ''){
                this.inputValue = 0;
              }
              this.keyboardShow = false;
          },


    // 判断平台
    judgeClient() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
        this.client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
        this.client = 'Android';
      } else {
        this.client = 'PC';
      }
      return this.client;
    },
            contact() {
                axios
                    .get(this.$serviceIp +`api/trade/card/tx/getInfoForWeb?token=${this.token}&uid=${this.uid}`,{
                        headers: {
                            'deviceId': this.deviceId
                        }
                    })
                    .then((response) => {
                    if (response.data.code == 200) {
                        this.listData = response.data.data;
                        this.sortList(this.listData.item);
                    } else {
                        Toast(response.data.message || this.$t("transfer.error"));
                    }
                    }).catch(()=>{

                    }).finally(()=>{
                        this.loading = false
                    });
            },
    // 排序
    sortList(item){
      item.forEach(element => {
        element.list.sort((a, b) => {
          return a.sort - b.sort;
        });
      });
    },
            changeTime() {
                let item = JSON.parse(localStorage.getItem("time"));
                if (item < Date.now()) {
                    localStorage.removeItem("data");
                    localStorage.removeItem("time");
                    this.$router.push("/withdrawalLogin");
                }
            },
            
    channelBtn(item, Aitem) {
        console.log(this.listData.cin, Aitem.usd)
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/withdrawalDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
                id:item.id,
                sabankList: JSON.stringify(response.data.data.sabankList) || ''
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
            
    channelPixBtn(item, Aitem) {
      if (this.listData.cin < Aitem.usd) {
        this.show = true;
        return;
      }
      axios
        .get(
          this.$serviceIp +
            `/api/trade/card/tx/initForWeb?token=${this.token}&uid=${this.uid}&id=${item.id}`,{
              headers: {
                'deviceId': this.deviceId
              }
            }
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.$router.push({
              path: "/pixDetails",
              query: {
                obj: JSON.stringify(response.data.data.infos),
                newobj: JSON.stringify(Aitem),
              },
            });
          } else {
            Toast(response.data.message || this.$t("transfer.error"));
          }
        });
    },
        }
    }
</script>
<style scoped>
html[lang="ar"] .to-number{
  text-align: right;
}
html[lang="ar"] .custom-amount-btn::after{
  transform: scale(-1);
}
html[lang="ar"] .list-box{
  margin-right: 22px;
  margin-left: 0;
}
html[lang="ar"] .list .list-box:nth-of-type(3n+1){
  margin-right: 0;
}
.amount-min{
  font-size: 24px;
  font-weight: 500;
  color: #F46363;
  text-align: center;
}
.acual-amount{
  font-size: 24px;
  font-weight: 400;
  color: #89848D;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 4px;
}
.acual-num{
  font-size: 48px;
  font-weight: 900;
  color: #4D70FF;
  text-align: center;
}
.acual-num span{
  font-size: 28px;
  margin-right: 10px;
}
.pop-btn-box{
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 32px;
}
.pop-btn-box span{
  width: 200px;
  height: 64px;
  text-align: center;
  border-radius: 100px;
  font-size: 24px;
  line-height: 64px;
  font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
}
.pop-btn-box span:nth-of-type(1){
  background-color: #DFD9E3;
  color: #262427;
}
.pop-btn-box span:nth-of-type(2){
  background-color: #4D70FF;
  color: #fff;
}
.pop-btn-box span.btn-disabled{
  background-color: #C0C4CC;
  pointer-events: none;
}
.amount-box{
  width: 592px;
  /* height: 673px; */
  border-radius: 24px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding: 32px 48px;
  padding-bottom: 55px;
  box-sizing: border-box;
  transition: top 0.3s ease;
}
.keyboard-active{
  top: 30%!important;
}
.amount-title{
  font-size: 28px;
  font-weight: 500;
  color: #1f1315;
  margin-bottom: 16px;
  text-align: center;
}
.to-number {
  font-size: 24px;
  font-weight: 400;
  color: #262427;
  margin-bottom: 8px;
  text-align: left;
}
/* 关键：输入框容器 */
.input-wrapper {
  width: 100%;
  height: 88px;
  border: 1px solid #dbdbdb;
  border-radius: 24px;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
  background: white;
  box-sizing: border-box;
  position: relative;
}
.coin-icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0; /* 防止被压缩 */
}
/* 隐藏的测量元素 */
.measure {
  position: absolute;
  visibility: hidden;
  white-space: pre; /* 保留空格和换行 */
  font-size: 16px;
  font-family: "Mada", sans-serif;
  padding: 4px 10px;
  top: -9999px;
  left: -9999px;
}
.center-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 28px;
  text-align: center; /* 因为图标在左，数字紧随其后 */
  width: 40px;
  padding: 0;
  line-height: 1;
}

.tp-number-tips{
    font-size: 24px;
    font-weight: 400;
    color: #262427;
    display: flex;
    /* justify-content: center; */
    margin: 26px 0 10px;
    text-align: left;
}
.tp-number-tips span{
    display: flex;
    align-items: center;
    margin-left: 4px;
}
.tp-number-tips span::before{
    content: "";
    width: 36px;
    height: 36px;
    background: url("../../assets/withdrawal/coin.png") no-repeat;
    background-size: 100% 100%;
    margin-bottom: -4px;
}

.gear-box{
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
    border-bottom: 0.5px solid #DFD9E3;
}
.gear-box li{
    width: 106px;
    height: 64px;
    border: 1px solid #DFD9E3;
    border-radius: 16px;
    font-size: 24px;
    line-height: 64px;
    color: #89848D;
    text-align: center;
    font-weight: 500;
}
.act-gear{
    color: #4D70FF!important;
    border-color: #4D70FF!important;
}
.tips-box{
    width: 544px;
    margin: 0 auto;
    /* margin-top: 48px; */
    padding: 16px 24px;
    border-radius: 24px;
    box-sizing: border-box;
    background: linear-gradient(to bottom, rgba(255, 147, 147, 0.6),rgba(255, 147, 147, 0));
}
.tips-box header{
    font-size: 24px;
    color: #FF4365;
    font-weight: 500;
    display: flex;
    margin-bottom: 20px;
}
.tips-box header::before{
    content:'';
    width: 32px;
    line-height: 32px;
    background: url("../../assets/withdrawal/elert.png") no-repeat;
    background-size: 100%;
    margin-right: 16px;
}
.custom-amount-btn{
  font-size: 24px;
  font-weight: 500;
  color: #262427;
  flex-direction:row!important;
  justify-content: center!important;
  text-align: center;
}
.custom-amount-btn::after{
  width: 28px;
  height: 28px;
  content:'';
  background: url("../../assets/withdrawal/custom.png") no-repeat;
  background-size: 100% 100%;
}
.popup {
  font-size: 0.24rem;
  color: #000000;
  font-weight: 500;
  font-family: Rubik;
  display: flex;
  justify-content: center;
  align-items: center;
}
html[lang="ar"] .list {
  direction: rtl;
}
.meta-box{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
}
.list {
  width: 100%;
  /* height: 1.9rem; */
  margin-bottom: 0.4rem;
}
.list .list-box:nth-of-type(3n+1) {
  margin-left: 0;
}
.list-box {
  width: 166px;
  min-height: 128px;
  margin-top: 0.3rem;
  margin-left: 22px;
  border-radius: 24px;
  /* border: 1px solid rgba(0, 210, 147, 1); */
  background: #E8ECF0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.list-txt {
  height: 0.32rem;
  font-size: 0.27rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 1);
}
.tips{
  height: 0.32rem;
  font-size: 0.20rem;
  font-family: Rubik;
  color: rgba(0, 0, 0, 0.7);

}
.money {
  width: 80%;
  min-height: 0.43rem;
  font-size: 0.37rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  text-align: center;
  word-wrap: break-word;
  white-space: normal;
}

.money-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.money-img {
  width: 0.27rem;
  height: 0.27rem;
  object-fit: cover;
  margin-top: 0.05rem;
}

.money-num {
  /* width: 0.6rem; */
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.24rem;
  color: #89848D;
  font-weight: 500;
  font-family: Rubik;
}
/* 遮罩层 */
.custom-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end; /* 从底部对齐 */
  align-items: flex-end;
  z-index: 2;
  animation: fadeIn 0.3s ease;
}
</style>